import React from 'react';
import DataSheet from 'react-datasheet';
import './style.css';
import ChairComponent from '../chair/index';
import { withRouter } from 'react-router-dom';

export default withRouter(class ViewChairsComponent extends React.Component {
    state = {}

    static getDerivedStateFromProps(nextProps, prevState) {
        let timeToNumber = (time) => {
            let numbers = time.split(":")
            return Number(numbers[0]) + Number(numbers[1])/100
        }

        let {chair} = nextProps;
        let appointments = nextProps.appointments.filter(appointment => appointment.chair == chair)
        appointments = appointments.map(appointment => {
            let doctor = nextProps.doctors.find(doctor => doctor._id == appointment.doctor)
            let diagnostic;
            if(appointment.old)
                diagnostic = {
                    name: appointment.diagnostic
                }
            else
                diagnostic = nextProps.diagnostics.find(diagnostic => diagnostic._id == appointment.diagnostic)
            let patient = nextProps.patients.find(patient => patient._id == appointment.patient)

            return {
                appointment: appointment,
                doctor: doctor,
                patient: patient,
                diagnostic: diagnostic
            }
        })
        appointments = appointments.sort((a,b) => {
            return timeToNumber(a.appointment.time) - timeToNumber(b.appointment.time)
        })
        return {
            chair: chair,
            appointments: appointments
        };
    }

    redirect = () => {
        this.props.history.push(`/home/edit-single/${this.props.date.getTime()}/${this.props.chair}`)
    }

    openDetails = (id) => {
        this.props.history.push("/appointment-details/" + id + "/" + this.props.date.getTime() + "/" + this.props.chair)
    }

    render() {
        return (
            <div className="ViewChairs">
                <div className="card">
                    <div className="card-header">
                        <p className="card-header-title">Silla {this.state.chair}</p>
                        <a className="card-header-icon header-button"
                            onClick={this.redirect}
                        >
                            <span className="icon">
                                <i className="fas fa-plus" aria-hidden="true"></i>
                            </span>
                        </a>
                    </div>
                    <div className="card-content">
                        <ChairComponent {...this.state} details={this.openDetails} />
                    </div>
                </div>
            </div>
        );
    }
})


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/home/scenes/pick-day/components/view-chairs/index.js